import { type FC } from 'react';
import DiscordIcon from '@assets/img/icons/discord.svg?react';
import InstagramIcon from '@assets/img/icons/instagram.svg?react';
import TelegramIcon from '@assets/img/icons/telegram.svg?react';
import TiktokIcon from '@assets/img/icons/tiktok.svg?react';
import XIcon from '@assets/img/icons/x.svg?react';
import YoutubeIcon from '@assets/img/icons/youtube.svg?react';

import { SocialWrapper } from '../SocialWrapper/SocialWrapper';

interface prop {
  link?: string;
}

const TelegramSocial: FC<prop> = ({ link }) => {
  return (
    <SocialWrapper name="telegram" link={link}>
      <TelegramIcon className="w-7 h-7 shrink-0" />
    </SocialWrapper>
  );
};

const XSocial: FC<prop> = ({ link }) => {
  return (
    <SocialWrapper name="x" link={link}>
      <XIcon className="w-7 h-7 shrink-0" />
    </SocialWrapper>
  );
};

const DiscordSocial: FC<prop> = ({ link }) => {
  return (
    <SocialWrapper name="discord" link={link}>
      <DiscordIcon className="w-7 h-7 shrink-0" />
    </SocialWrapper>
  );
};

const YoutubeSocial: FC<prop> = ({ link }) => {
  return (
    <SocialWrapper name="youtube" link={link}>
      <YoutubeIcon className="w-7 h-7 shrink-0" />
    </SocialWrapper>
  );
};

const InstagramSocial: FC<prop> = ({ link }) => {
  return (
    <SocialWrapper name="instagram" link={link}>
      <InstagramIcon className="w-7 h-7 shrink-0" />
    </SocialWrapper>
  );
};

const TiktokSocial: FC<prop> = ({ link }) => {
  return (
    <SocialWrapper name="tiktok" link={link}>
      <TiktokIcon className="w-7 h-7 shrink-0" />
    </SocialWrapper>
  );
};

export {
  DiscordSocial,
  InstagramSocial,
  TelegramSocial,
  TiktokSocial,
  XSocial,
  YoutubeSocial,
};
